<template>
    <router-view />
</template>

<script>
export default {
    name: 'TheUserSettings'
}
</script>
